const facebookLinks = [...document.querySelectorAll('.js-share-facebook')];
const twitterLinks = [...document.querySelectorAll('.js-share-twitter')];
const linkedInLinks = [...document.querySelectorAll('.js-share-linkedin')];

facebookLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        const encoded = encodeURIComponent(window.SITE_URL);
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encoded}`,
            '_blank',
            'toolbar=no,scrollbars=yes,resizable=yes,width=555,height=624'
        );
    });
});


twitterLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
        event.preventDefault();

        const encoded = encodeURIComponent(window.SITE_URL);
        const href = `https://twitter.com/intent/tweet?text=${document.title}&url=${encoded}`;
        window.open(href, '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,width=555,height=624');
    });
});


linkedInLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
        event.preventDefault();

        const encoded = encodeURIComponent(window.SITE_URL);
        const href = `https://www.linkedin.com/shareArticle?mini=true&url=${encoded}`;
        window.open(href, '_blank', 'toolbar=no,scrollbars=yes,resizable=yes,width=555,height=624');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/share.js